import React from 'react';
import { parseLinks, linkStyles } from '../lib/linkify';

/**
 * Component that renders text with clickable links highlighted
 * Links open in a new tab/window
 */
const LinkifiedText = ({ 
  text, 
  className = '', 
  linkClassName = linkStyles.default,
  as: Component = 'span'
}) => {
  if (!text) return null;
  
  const segments = parseLinks(text);
  
  return (
    <Component className={className}>
      {segments.map((segment, index) => {
        if (segment.type === 'link') {
          return (
            <a
              key={index}
              href={segment.href}
              target="_blank"
              rel="noopener noreferrer"
              className={linkClassName}
              onClick={(e) => e.stopPropagation()}
            >
              {segment.content}
            </a>
          );
        }
        return <span key={index}>{segment.content}</span>;
      })}
    </Component>
  );
};

export default LinkifiedText;
